import React, { useEffect, useState, useContext } from 'react';
import { connect } from 'react-redux';
import {
	Row,
	Col,
	Card,
	Result,
	Input,
	Divider,
	Typography,
	notification,
	Button,
	Space,
} from 'antd';
import { RightOutlined, LeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import {
	XThemeForm,
	XThemeInputText,
	XThemeRadio,
	XThemeNextPrevBtn,
} from '../../styles/GlobalThemeStyle';
// actions

import {
	editPayerConfigurationApi,
	editPayerConfigurationReset,
} from '../../actions/editPayerConfigurationAction';

import { checkModulePermissions, truncateString } from '../../utils/helper';
import { dateFilters } from '../../utils/constants';
import HeaderFile from '../../components/Header/HeaderFile';
import DataTable from '../../components/DataTable/DataTable';
import Header from '../../components/Header/Header';
import { XButtonImg } from '../Manage/ManageStyle';
import { filterByLabel } from '../../utils/formFunctions';
import { FormDataContext } from './PayerConfigurationForm';
import { XTheme2Button } from '../../styles/GlobalThemeStyleCQ';
const { Text, Link } = Typography;

const Step3 = (props) => {
	const {
		editPayerConfiguration,
		editPayerConfigurationReset,
		editPayerConfigurationState,
	} = props;

	const { form, formDataState, currentState, editModeState } =
		useContext(FormDataContext);

	useEffect(() => {
		if (editPayerConfigurationState.apiState == 'success') {
			// currentState.setCurrent((old)=>{
			//     return old+1;
			// });

			notification.success({
				message: editPayerConfigurationState.message,
			});
			editPayerConfigurationReset();
		}
	}, [editPayerConfigurationState]);

	const handlePrev = () => {
		currentState.setCurrent((old) => {
			return old - 1;
		});
	};

	const handleNext = () => {
		form.validateFields([
			'post_claim-rc-organization_determination-timeline',
			'post_claim-rc-organization_determination-timeline_type',
			'post_claim-rc-organization_determination-in_process',
			'post_claim-rc-organization_determination-at_risk',
			'post_claim-rc-organization_determination-escalation',
			'post_claim-rc-organization_determination-untimely',
			'post_claim-rc-first_appeal-timeline',
			'post_claim-rc-first_appeal-timeline_type',
			'post_claim-rc-first_appeal-in_process',
			'post_claim-rc-first_appeal-at_risk',
			'post_claim-rc-first_appeal-escalation',
			'post_claim-rc-first_appeal-untimely',
			'post_claim-rc-second_appeal-timeline',
			'post_claim-rc-second_appeal-timeline_type',
			'post_claim-rc-second_appeal-in_process',
			'post_claim-rc-second_appeal-at_risk',
			'post_claim-rc-second_appeal-escalation',
			'post_claim-rc-second_appeal-untimely',
			'post_claim-rc-third_appeal-timeline',
			'post_claim-rc-third_appeal-timeline_type',
			'post_claim-rc-third_appeal-in_process',
			'post_claim-rc-third_appeal-at_risk',
			'post_claim-rc-third_appeal-escalation',
			'post_claim-rc-third_appeal-untimely',
			'post_claim-rc-fourth_appeal-timeline',
			'post_claim-rc-fourth_appeal-timeline_type',
			'post_claim-rc-fourth_appeal-in_process',
			'post_claim-rc-fourth_appeal-at_risk',
			'post_claim-rc-fourth_appeal-escalation',
			'post_claim-rc-fourth_appeal-untimely',
			'post_claim-rc-judicial_review-timeline',
			'post_claim-rc-judicial_review-timeline_type',
			'post_claim-rc-judicial_review-in_process',
			'post_claim-rc-judicial_review-at_risk',
			'post_claim-rc-judicial_review-escalation',
			'post_claim-rc-judicial_review-untimely',
			'post_claim-ma_standard-organization_determination-timeline',
			'post_claim-ma_standard-organization_determination-timeline_type',
			'post_claim-ma_standard-organization_determination-in_process',
			'post_claim-ma_standard-organization_determination-at_risk',
			'post_claim-ma_standard-organization_determination-escalation',
			'post_claim-ma_standard-organization_determination-untimely',
			'post_claim-ma_standard-first_appeal-timeline',
			'post_claim-ma_standard-first_appeal-timeline_type',
			'post_claim-ma_standard-first_appeal-in_process',
			'post_claim-ma_standard-first_appeal-at_risk',
			'post_claim-ma_standard-first_appeal-escalation',
			'post_claim-ma_standard-first_appeal-untimely',
			'post_claim-ma_standard-second_appeal-timeline',
			'post_claim-ma_standard-second_appeal-timeline_type',
			'post_claim-ma_standard-second_appeal-in_process',
			'post_claim-ma_standard-second_appeal-at_risk',
			'post_claim-ma_standard-second_appeal-escalation',
			'post_claim-ma_standard-second_appeal-untimely',
			'post_claim-ma_standard-third_appeal-timeline',
			'post_claim-ma_standard-third_appeal-timeline_type',
			'post_claim-ma_standard-third_appeal-in_process',
			'post_claim-ma_standard-third_appeal-at_risk',
			'post_claim-ma_standard-third_appeal-escalation',
			'post_claim-ma_standard-third_appeal-untimely',
			'post_claim-ma_standard-fourth_appeal-timeline',
			'post_claim-ma_standard-fourth_appeal-timeline_type',
			'post_claim-ma_standard-fourth_appeal-in_process',
			'post_claim-ma_standard-fourth_appeal-at_risk',
			'post_claim-ma_standard-fourth_appeal-escalation',
			'post_claim-ma_standard-fourth_appeal-untimely',
			'post_claim-ma_standard-judicial_review-timeline',
			'post_claim-ma_standard-judicial_review-timeline_type',
			'post_claim-ma_standard-judicial_review-in_process',
			'post_claim-ma_standard-judicial_review-at_risk',
			'post_claim-ma_standard-judicial_review-escalation',
			'post_claim-ma_standard-judicial_review-untimely',
		])
			.then((values) => {
				formDataState.setFormData((old) => {
					return { ...old, ...values };
				});
				currentState.setCurrent((old) => {
					return old + 1;
				});
			})
			.catch((error) => {
				return;
			});
	};

	const handleUpdate = () => {
		form.validateFields([
			'post_claim-rc-organization_determination-timeline',
			'post_claim-rc-organization_determination-timeline_type',
			'post_claim-rc-organization_determination-in_process',
			'post_claim-rc-organization_determination-at_risk',
			'post_claim-rc-organization_determination-escalation',
			'post_claim-rc-organization_determination-untimely',
			'post_claim-rc-first_appeal-timeline',
			'post_claim-rc-first_appeal-timeline_type',
			'post_claim-rc-first_appeal-in_process',
			'post_claim-rc-first_appeal-at_risk',
			'post_claim-rc-first_appeal-escalation',
			'post_claim-rc-first_appeal-untimely',
			'post_claim-rc-second_appeal-timeline',
			'post_claim-rc-second_appeal-timeline_type',
			'post_claim-rc-second_appeal-in_process',
			'post_claim-rc-second_appeal-at_risk',
			'post_claim-rc-second_appeal-escalation',
			'post_claim-rc-second_appeal-untimely',
			'post_claim-rc-third_appeal-timeline',
			'post_claim-rc-third_appeal-timeline_type',
			'post_claim-rc-third_appeal-in_process',
			'post_claim-rc-third_appeal-at_risk',
			'post_claim-rc-third_appeal-escalation',
			'post_claim-rc-third_appeal-untimely',
			'post_claim-rc-fourth_appeal-timeline',
			'post_claim-rc-fourth_appeal-timeline_type',
			'post_claim-rc-fourth_appeal-in_process',
			'post_claim-rc-fourth_appeal-at_risk',
			'post_claim-rc-fourth_appeal-escalation',
			'post_claim-rc-fourth_appeal-untimely',
			'post_claim-rc-judicial_review-timeline',
			'post_claim-rc-judicial_review-timeline_type',
			'post_claim-rc-judicial_review-in_process',
			'post_claim-rc-judicial_review-at_risk',
			'post_claim-rc-judicial_review-escalation',
			'post_claim-rc-judicial_review-untimely',
			'post_claim-ma_standard-organization_determination-timeline',
			'post_claim-ma_standard-organization_determination-timeline_type',
			'post_claim-ma_standard-organization_determination-in_process',
			'post_claim-ma_standard-organization_determination-at_risk',
			'post_claim-ma_standard-organization_determination-escalation',
			'post_claim-ma_standard-organization_determination-untimely',
			'post_claim-ma_standard-first_appeal-timeline',
			'post_claim-ma_standard-first_appeal-timeline_type',
			'post_claim-ma_standard-first_appeal-in_process',
			'post_claim-ma_standard-first_appeal-at_risk',
			'post_claim-ma_standard-first_appeal-escalation',
			'post_claim-ma_standard-first_appeal-untimely',
			'post_claim-ma_standard-second_appeal-timeline',
			'post_claim-ma_standard-second_appeal-timeline_type',
			'post_claim-ma_standard-second_appeal-in_process',
			'post_claim-ma_standard-second_appeal-at_risk',
			'post_claim-ma_standard-second_appeal-escalation',
			'post_claim-ma_standard-second_appeal-untimely',
			'post_claim-ma_standard-third_appeal-timeline',
			'post_claim-ma_standard-third_appeal-timeline_type',
			'post_claim-ma_standard-third_appeal-in_process',
			'post_claim-ma_standard-third_appeal-at_risk',
			'post_claim-ma_standard-third_appeal-escalation',
			'post_claim-ma_standard-third_appeal-untimely',
			'post_claim-ma_standard-fourth_appeal-timeline',
			'post_claim-ma_standard-fourth_appeal-timeline_type',
			'post_claim-ma_standard-fourth_appeal-in_process',
			'post_claim-ma_standard-fourth_appeal-at_risk',
			'post_claim-ma_standard-fourth_appeal-escalation',
			'post_claim-ma_standard-fourth_appeal-untimely',
			'post_claim-ma_standard-judicial_review-timeline',
			'post_claim-ma_standard-judicial_review-timeline_type',
			'post_claim-ma_standard-judicial_review-in_process',
			'post_claim-ma_standard-judicial_review-at_risk',
			'post_claim-ma_standard-judicial_review-escalation',
			'post_claim-ma_standard-judicial_review-untimely',
		])
			.then((values) => {
				formDataState.setFormData((old) => {
					return { ...old, ...values };
				});

				editPayerConfiguration({
					update_type: 'post_claim',
					id: formDataState.formData.id,
					...values,
				});
			})
			.catch((error) => {
				return;
			});
	};

	const navigate = useNavigate();

	return (
		<>
			<XThemeForm
				form={form}
				name="timelineConfigFrom"
				layout="vertical"
				autoComplete="off"
			>
				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<p className="modalPara1 text-dark m-0">
							<strong>RC</strong>
						</p>
					</Col>
				</Row>
				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Organization Determination</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-organization_determination-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="post_claim-rc-organization_determination-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-organization_determination-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-organization_determination-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="post_claim-rc-organization_determination-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-organization_determination-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="post_claim-rc-organization_determination-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-organization_determination-escalation"
							label="Escalation"
							rules={[
								{
									required: true,
									message: 'Please enter Escalation start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Escalation Start"
								name="post_claim-rc-organization_determination-escalation"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-organization_determination-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="post_claim-rc-organization_determination-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>First Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-first_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="post_claim-rc-first_appeal-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-first_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-first_appeal-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="post_claim-rc-first_appeal-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-first_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="post_claim-rc-first_appeal-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-first_appeal-escalation"
							label="Escalation"
							rules={[
								{
									required: true,
									message: 'Please enter Escalation start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Escalation Start"
								name="post_claim-rc-first_appeal-escalation"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-first_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="post_claim-rc-first_appeal-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Second Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-second_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="post_claim-rc-second_appeal-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-second_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-second_appeal-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="post_claim-rc-second_appeal-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-second_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="post_claim-rc-second_appeal-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-second_appeal-escalation"
							label="Escalation"
							rules={[
								{
									required: true,
									message: 'Please enter Escalation start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Escalation Start"
								name="post_claim-rc-second_appeal-escalation"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-second_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="post_claim-rc-second_appeal-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Third Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-third_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="post_claim-rc-third_appeal-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-third_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-third_appeal-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="post_claim-rc-third_appeal-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-third_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="post_claim-rc-third_appeal-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-third_appeal-escalation"
							label="Escalation"
							rules={[
								{
									required: true,
									message: 'Please enter Escalation start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Escalation Start"
								name="post_claim-rc-third_appeal-escalation"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-third_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="post_claim-rc-third_appeal-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Fourth Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-fourth_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="post_claim-rc-fourth_appeal-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-fourth_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-fourth_appeal-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="post_claim-rc-fourth_appeal-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-fourth_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="post_claim-rc-fourth_appeal-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-fourth_appeal-escalation"
							label="Escalation"
							rules={[
								{
									required: true,
									message: 'Please enter Escalation start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Escalation Start"
								name="post_claim-rc-fourth_appeal-escalation"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-fourth_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="post_claim-rc-fourth_appeal-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Judicial Review</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-judicial_review-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="post_claim-rc-judicial_review-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-judicial_review-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-judicial_review-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="post_claim-rc-judicial_review-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-judicial_review-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="post_claim-rc-judicial_review-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-judicial_review-escalation"
							label="Escalation"
							rules={[
								{
									required: true,
									message: 'Please enter Escalation start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Escalation Start"
								name="post_claim-rc-judicial_review-escalation"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-rc-judicial_review-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="post_claim-rc-judicial_review-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)} className="mt-4">
					<Col xs={24}>
						<p className="modalPara1 text-dark m-0">
							<strong>MA Standard</strong>
						</p>
					</Col>
				</Row>
				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Organization Determination</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-organization_determination-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="post_claim-ma_standard-organization_determination-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-organization_determination-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-organization_determination-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="post_claim-ma_standard-organization_determination-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-organization_determination-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="post_claim-ma_standard-organization_determination-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-organization_determination-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="post_claim-ma_standard-organization_determination-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>First Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-first_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="post_claim-ma_standard-first_appeal-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-first_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-first_appeal-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="post_claim-ma_standard-first_appeal-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-first_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="post_claim-ma_standard-first_appeal-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-first_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="post_claim-ma_standard-first_appeal-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Second Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-second_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="post_claim-ma_standard-second_appeal-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-second_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-second_appeal-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="post_claim-ma_standard-second_appeal-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-second_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="post_claim-ma_standard-second_appeal-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-second_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="post_claim-ma_standard-second_appeal-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Third Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-third_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="post_claim-ma_standard-third_appeal-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-third_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-third_appeal-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="post_claim-ma_standard-third_appeal-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-third_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="post_claim-ma_standard-third_appeal-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-third_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="post_claim-ma_standard-third_appeal-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Fourth Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-fourth_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="post_claim-ma_standard-fourth_appeal-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-fourth_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-fourth_appeal-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="post_claim-ma_standard-fourth_appeal-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-fourth_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="post_claim-ma_standard-fourth_appeal-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-fourth_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="post_claim-ma_standard-fourth_appeal-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Judicial Review</Text>
						</Divider>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-judicial_review-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="post_claim-ma_standard-judicial_review-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-judicial_review-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-judicial_review-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="post_claim-ma_standard-judicial_review-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-judicial_review-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="post_claim-ma_standard-judicial_review-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="post_claim-ma_standard-judicial_review-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="post_claim-ma_standard-judicial_review-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={[15, 15]}>
					{editModeState.editMode ? (
						<Col xs={24} className="text-center text-md-end">
							<Space>
								<XTheme2Button
									className="noBackground"
									onClick={handlePrev}
								>
									<LeftOutlined />
									Previous
								</XTheme2Button>

								<XTheme2Button onClick={handleNext}>
									Next
									<RightOutlined />
								</XTheme2Button>
								<Divider
									type="vertical"
									style={{
										height: '30px',
										marginInline: '20px',
									}}
									orientationMargin={1}
								/>
								<XTheme2Button onClick={handleUpdate}>
									Update
								</XTheme2Button>
							</Space>
						</Col>
					) : (
						<Col xs={24} className="text-end text-md-end">
							<Space>
								<XTheme2Button
									className="noBackground"
									onClick={handlePrev}
								>
									<LeftOutlined />
									Previous
								</XTheme2Button>

								<XTheme2Button onClick={handleNext}>
									Next
									<RightOutlined />
								</XTheme2Button>
							</Space>
						</Col>
					)}
				</Row>
			</XThemeForm>
		</>
	);
};

const mapStateToProps = (state) => ({
	editPayerConfigurationState: state.editPayerConfiguration,
});

const mapDispatchToProps = (dispatch) => ({
	editPayerConfiguration: (data) => dispatch(editPayerConfigurationApi(data)),
	editPayerConfigurationReset: () => dispatch(editPayerConfigurationReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Step3);
